export const getSessionStorage = (key: string) => {
  if (typeof window !== 'undefined') {
    const value = window.sessionStorage.getItem(key);
    if (value === null) return null;
    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  }
  return null;
};

export const getSessionStorageWithoutParse = (key: string) => {
  if (typeof window !== 'undefined') {
    return window.sessionStorage.getItem(key);
  }
  return null;
};

export const setSessionStorage = (key: string, value: any) => {
  if (typeof window !== 'undefined') {
    window.sessionStorage.setItem(key, JSON.stringify(value));
  }
  return getSessionStorage(key);
};

export const setSessionStorageWithoutParse = (key: string, value: any) => {
  if (typeof window !== 'undefined') {
    window.sessionStorage.setItem(key, value);
  }
  return getSessionStorageWithoutParse(key);
};

export const removeSessionStorage = (key: string) => {
  if (typeof window !== 'undefined') {
    window.sessionStorage.removeItem(key);
  }
};

export const clearSessionStorage = () => {
  if (typeof window !== 'undefined') {
    window.sessionStorage.clear();
  }
};
